import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';

const MainLayout = (props) => {
  const { children } = props;
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), { defaultMatches: true });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => setOpenSidebar(true);
  const handleSidebarClose = () => setOpenSidebar(false);

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  // Use useEffect to apply global styles for html, body, and #root
  useEffect(() => {
    // Set the global styles when the component mounts
    document.documentElement.style.height = '100%';
    document.body.style.height = '100%';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.getElementById('root').style.height = '100%';

    // Cleanup function to reset the styles when the component unmounts
    return () => {
      document.documentElement.style.height = '';
      document.body.style.height = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.getElementById('root').style.height = '';
    };
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Garante que ocupe 100% da altura da tela
        margin: 0,
        padding: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          position: 'relative',
        }}
      >
        <Sidebar
          onClose={handleSidebarClose}
          open={shouldOpenSidebar}
          variant={isDesktop ? 'persistent' : 'temporary'}
          sx={{ width: isDesktop ? 240 : 0 }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            paddingLeft: isDesktop ? '240px' : '0',
            paddingTop: '60px',
            boxSizing: 'border-box',
            position: 'relative',
          }}
        >
          <Topbar onSidebarOpen={handleSidebarOpen} />
          <Box
            sx={{
              flexGrow: 1, // Expande para ocupar o espaço restante da tela
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
            }}
          >
            {children}
          </Box>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
